import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  RequestResult,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from '../../lib'
import {IIdentityProjectSettings} from '../../shared/db'
import {doPROJECT_SETTINGS_SET, doREQUEST_COMPLETE, doREQUEST_ERROR} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE = 'REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE'
export const doREQUEST_IDENTITY_PROJECT_SETTINGS_CREATE = createDoRequestAction(
  REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE,
)

export const requestIdentityProjectSettingsCreateActionCreators = {
  doREQUEST_IDENTITY_PROJECT_SETTINGS_CREATE,
}

interface Payload {
  type: string
  payload: {
    requestId: string
    projectId: string
    visualizerSidebarSetting: IIdentityProjectSettings['visualizerSidebarSetting']
  }
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestIdentityProjectSettingsCreate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestIdentityProjectSettingsCreate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        visualizerSidebarSetting: v.object().optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, visualizerSidebarSetting} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'POST',
    url: `${API_URL}/v1/web/identity-project-settings-create`,
    accessToken,
    data: {
      projectId,
      visualizerSidebarSetting,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-project-settings-create',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SETTINGS_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* identityProjectSettingsCreateSaga() {
  yield takeEvery(REQUEST_IDENTITY_PROJECT_SETTINGS_CREATE, requestIdentityProjectSettingsCreate)
}
